module.exports = __webpack_public_path__ + "img/page.6bbd0492.png";